import { __assign } from "tslib";
import { testDataCreator } from '@wix/answers-lib';
import { creteEmptyScenario, RecipeType } from '.';
import { AgentBuilder } from '../common';
import { changeTicketStatusActionBuilder, addInternalNoteActionBuilder, addAgentReplyActionBuilder, setAssigneeTicketActionBuilder, setTicketLabelsActionBuilder, createNotificationActionBuilder, sendChatAutoReplyBuilder, createArticleTaskBuilder, endAllHandlingActionBuilder, unassignTicketActionBuilder, setTicketPriorityActionBuilder } from './actions.builders';
export var scenarioMetaDataBuilder = testDataCreator(function (props) {
    return {
        timesUsed: (props === null || props === void 0 ? void 0 : props.timesUsed) || 5,
        createdBy: new AgentBuilder().build(),
        disabled: (props === null || props === void 0 ? void 0 : props.disabled) || false,
        creationDate: (props === null || props === void 0 ? void 0 : props.creationDate) || Date.now(),
        lastUpdateDate: (props === null || props === void 0 ? void 0 : props.lastUpdateDate) || Date.now(),
        id: (props === null || props === void 0 ? void 0 : props.id) || '123-123',
        valid: true,
    };
});
export var ticketPendingScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.TICKET_PENDING,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [
            changeTicketStatusActionBuilder(),
            addInternalNoteActionBuilder(),
            addAgentReplyActionBuilder(),
            setAssigneeTicketActionBuilder(),
            setTicketLabelsActionBuilder(),
            createNotificationActionBuilder(),
        ],
    };
});
export var savedTicketPendingScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), ticketPendingScenarioBuilder());
});
export var callInProcessTooLongScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.DETECT_LONG_CALLS,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [createNotificationActionBuilder()],
    };
});
export var savedCallInProcessTooLongScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), callInProcessTooLongScenarioBuilder());
});
export var automateAgentResponseInChatScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.AUTOMATE_AGENT_RESPONSE_IN_CHAT,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [sendChatAutoReplyBuilder(), createNotificationActionBuilder()],
    };
});
export var savedAutomateAgentResponseInChatBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), automateAgentResponseInChatScenarioBuilder());
});
export var alertCallCenterWorkloadScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.ALERT_CALL_CENTER_WORKLOAD,
        timePeriodMinutes: null,
        number: null,
        callStatusGroup: null,
        mustConditions: [],
        actions: [createNotificationActionBuilder()],
    };
});
export var savedAlertCallCenterWorkloadScenariotBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), alertCallCenterWorkloadScenarioBuilder());
});
export var reduceCallbackWaitTimeScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.REDUCE_CALLBACK_WAIT_TIME,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [createNotificationActionBuilder()],
    };
});
export var savedReduceCallbackWaitTimeScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), reduceCallbackWaitTimeScenarioBuilder());
});
export var fixUnhelpfulArticlesScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.FIX_UNHELPFUL_ARTICLES,
        number: null,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [createArticleTaskBuilder(), createNotificationActionBuilder()],
    };
});
export var savedFixUnhelpfulArticlesScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), fixUnhelpfulArticlesScenarioBuilder());
});
export var spotInefficientCallCenterAgentScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.MONITOR_CALL_CENTER_PRODUCTIVITY,
        number: null,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [createNotificationActionBuilder()],
    };
});
export var savedSpotInefficientCallCenterAgentScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), spotInefficientCallCenterAgentScenarioBuilder());
});
export var reduceTicketHandlingDelaysScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.REDUCE_TICKET_HANDLING_DELAYS,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [changeTicketStatusActionBuilder(), addInternalNoteActionBuilder()],
    };
});
export var savedReduceTicketHandlingDelaysScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), reduceTicketHandlingDelaysScenarioBuilder());
});
export var automateAbandonedChatResolutionBuilder = testDataCreator(function () { return ({
    recipeType: RecipeType.AUTOMATE_ABANDONED_CHAT_RESOLUTION,
    timePeriodMinutes: null,
    mustConditions: [],
    actions: [sendChatAutoReplyBuilder(), endAllHandlingActionBuilder()],
}); });
export var savedAutomateAbandonedChatResolutionBuilder = testDataCreator(function () { return (__assign(__assign({}, scenarioMetaDataBuilder()), automateAbandonedChatResolutionBuilder())); });
export var priorityChangedScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.ALERT_WHEN_PRIORITY_CHANGED,
        fromPriority: null,
        toPriority: null,
        mustConditions: [],
        actions: [setTicketLabelsActionBuilder(), addAgentReplyActionBuilder(), addInternalNoteActionBuilder(), createNotificationActionBuilder()],
    };
});
export var savedPriorityChangedScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), priorityChangedScenarioBuilder());
});
export var reduceCallCenterWaitScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.REDUCE_INBOUND_CALLS_WAIT_TIME,
        timePeriodMinutes: 0,
        mustConditions: [],
        actions: [addInternalNoteActionBuilder(), addAgentReplyActionBuilder(), setTicketLabelsActionBuilder(), createNotificationActionBuilder()],
    };
});
export var savedReduceCallCenterWaitScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), reduceCallCenterWaitScenarioBuilder());
});
export var detectTicketPingPongScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.DETECT_TICKET_PING_PONG,
        number: null,
        mustConditions: [],
        actions: [addInternalNoteActionBuilder(), createNotificationActionBuilder()],
    };
});
export var savedDetectTicketPingPongScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), detectTicketPingPongScenarioBuilder());
});
export var notifyAboutUnhappyCustomersScenarioBuilder = testDataCreator(function () {
    return {
        hasRatingComment: null,
        ratings: null,
        recipeType: RecipeType.NOTIFY_ABOUT_UNHAPPY_CUSTOMERS,
        mustConditions: [],
        actions: [addAgentReplyActionBuilder(), createNotificationActionBuilder()],
    };
});
export var savedNotifyAboutUnhappyCustomersScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), notifyAboutUnhappyCustomersScenarioBuilder());
});
export var ticketHasNotBeenAnsweredScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.TICKET_HAS_NOT_BEEN_ANSWERED,
        timePeriodMinutes: null,
        replyTypes: null,
        mustConditions: [],
        actions: [
            setTicketLabelsActionBuilder(),
            setAssigneeTicketActionBuilder(),
            changeTicketStatusActionBuilder(),
            createNotificationActionBuilder(),
        ],
    };
});
export var savedTicketHasNotBeenAnsweredScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), ticketHasNotBeenAnsweredScenarioBuilder());
});
export var escalateStuckTicketScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.ESCALATE_STUCK_TICKETS,
        timePeriodMinutes: null,
        ticketStatus: null,
        mustConditions: [],
        actions: [changeTicketStatusActionBuilder(), setAssigneeTicketActionBuilder(), createNotificationActionBuilder()],
    };
});
export var savedEscalateStuckTicketScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), escalateStuckTicketScenarioBuilder());
});
export var keepArticlesUpToDateScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.KEEP_ARTICLES_UP_TO_DATE,
        articleType: null,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [createArticleTaskBuilder(), createNotificationActionBuilder()],
    };
});
export var savedKeepArticlesUpToDateScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), keepArticlesUpToDateScenarioBuilder());
});
export var ticketAssignedToAgentOnLeaveScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.TICKET_ASSIGNED_TO_AGENT_ON_LEAVE,
        mustConditions: [],
        actions: [unassignTicketActionBuilder(), setTicketLabelsActionBuilder(), setAssigneeTicketActionBuilder(), createNotificationActionBuilder()],
    };
});
export var savedTicketAssignedToAgentOnLeaveScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), ticketAssignedToAgentOnLeaveScenarioBuilder());
});
export var tagIncompleteCallsScenarioBuilder = testDataCreator(function () {
    return {
        callStatuses: null,
        recipeType: RecipeType.TAG_INCOMPLETE_CALLS,
        mustConditions: [],
        actions: [
            changeTicketStatusActionBuilder(),
            addInternalNoteActionBuilder(),
            addAgentReplyActionBuilder(),
            setAssigneeTicketActionBuilder(),
            setTicketLabelsActionBuilder(),
            createNotificationActionBuilder(),
        ],
    };
});
export var savedTagIncompleteCallsScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), tagIncompleteCallsScenarioBuilder());
});
export var handleVoicemailMessagesScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.HANDLE_VOICEMAIL_MESSAGES,
        mustConditions: [],
        actions: [
            addInternalNoteActionBuilder(),
            addAgentReplyActionBuilder(),
            changeTicketStatusActionBuilder(),
            setAssigneeTicketActionBuilder(),
            setTicketLabelsActionBuilder(),
            setTicketPriorityActionBuilder(),
            createNotificationActionBuilder(),
        ],
    };
});
export var savedHandleVoicemailMessagesScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), handleVoicemailMessagesScenarioBuilder());
});
export var reduceChatWaitTimeScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.REDUCE_CHAT_WAIT_TIME,
        timePeriodMinutes: null,
        mustConditions: [],
        actions: [
            addInternalNoteActionBuilder(),
            addAgentReplyActionBuilder(),
            changeTicketStatusActionBuilder(),
            setAssigneeTicketActionBuilder(),
            setTicketLabelsActionBuilder(),
            createNotificationActionBuilder(),
        ],
    };
});
export var savedReduceChatWaitTimeScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), reduceChatWaitTimeScenarioBuilder());
});
export var monitorAgentCallCenterStatusScenarioBuilder = testDataCreator(function () {
    return {
        recipeType: RecipeType.MONITOR_AGENT_CALL_CENTER_STATUS,
        timePeriodMinutes: 0,
        callCenterAgentStatuses: [],
        agentCustomStatusId: null,
        mustConditions: [],
        actions: [createNotificationActionBuilder()],
    };
});
export var savedMonitorAgentCallCenterStatusScenarioBuilder = testDataCreator(function () {
    return __assign(__assign({}, scenarioMetaDataBuilder()), monitorAgentCallCenterStatusScenarioBuilder());
});
export var stagedScenarioBuilder = function (recipeType, override) {
    return testDataCreator(creteEmptyScenario(recipeType))(override);
};
export var savedScenarioBuilder = function (recipeType, override) {
    return testDataCreator(__assign(__assign({}, scenarioMetaDataBuilder()), creteEmptyScenario(recipeType)))(override);
};
//# sourceMappingURL=builders.js.map